var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3269 9.47075C11.5836 9.47075 11.8328 9.50232 12.082 9.54178V7.10306C12.082 6.23491 11.4099 5.52461 10.5717 5.52461H9.81661V3.94615C9.81661 1.76787 8.12513 0 6.04099 0C3.95685 0 2.26537 1.76787 2.26537 3.94615H3.77562C3.77562 2.63603 4.78749 1.57846 6.04099 1.57846C7.2945 1.57846 8.30636 2.63603 8.30636 3.94615V5.52461H1.51025C0.67206 5.52461 0 6.23491 0 7.10306V14.9954C0 15.8635 0.67206 16.5738 1.51025 16.5738H7.40777C7.02265 15.8793 6.79612 15.0743 6.79612 14.2061C6.79612 11.5938 8.8274 9.47075 11.3269 9.47075ZM6.04099 12.6277C5.21036 12.6277 4.53074 11.9253 4.53074 11.0492C4.53074 10.1732 5.21036 9.47075 6.04099 9.47075C6.87163 9.47075 7.55124 10.1811 7.55124 11.0492C7.55124 11.9174 6.87918 12.6277 6.04099 12.6277ZM12.3916 14.2061L14 15.8793L12.9277 17L11.3269 15.3189L9.726 17L8.66127 15.8793L10.2621 14.2061L8.66127 12.533L9.726 11.4201L11.3269 13.0933L12.9277 11.4201L14 12.533L12.3916 14.2061Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.24ef94e5422f4f8bf6e8a7b4dc0e93ca.svg";
export { ForwardRef as ReactComponent };